import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "_flex _gap-3 _pos-r" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-labels _ml-2"
}
const _hoisted_3 = { class: "_mw-0" }
const _hoisted_4 = { "format-key": "0" }
const _hoisted_5 = {
  key: 0,
  class: "_tc--error _mt-3",
  "data-qa": "cart-table-item-row-quantity-error:WarningIcon"
}
const _hoisted_6 = {
  key: 1,
  class: "_mt-3",
  "data-qa": "cart-table:SubitemsCount"
}
const _hoisted_7 = { "format-key": "0" }
const _hoisted_8 = { "format-key": "1" }
const _hoisted_9 = { "format-key": "0" }
const _hoisted_10 = { "format-key": "1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_image = _resolveComponent("base-image")
  const _component_router_link = _resolveComponent("router-link")
  const _component_base_title = _resolveComponent("base-title")
  const _component_localize = _resolveComponent("localize")
  const _component_balloon_actions = _resolveComponent("balloon-actions")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_cart_table_product_order_subitem = _resolveComponent("cart-table-product-order-subitem")
  const _component_order_item_modal = _resolveComponent("order-item-modal")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['_py-3 _bdb--thick', $options.borderColorClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: $options.to,
        title: $props.name
      }, {
        default: _withCtx(() => [
          ($options.badges.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.badges, (badge, index) => {
                  return (_openBlock(), _createBlock(_component_base_badge, {
                    key: index,
                    theme: badge.theme,
                    "data-qa": `cart-table:${badge.dataQa}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(badge.name), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme", "data-qa"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_base_image, {
            src: $props.imageUrl,
            alt: $props.name,
            class: "_rounded--common",
            loading: "lazy",
            width: "120",
            height: "120"
          }, null, 8 /* PROPS */, ["src", "alt"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to", "title"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_title, {
          as: "h3",
          level: $options.headerLevel,
          "data-qa": "cart-table:ProductName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: $options.to,
              title: $props.name
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "title"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["level"]),
        _createVNode(_component_base_title, {
          level: $options.headerLevel,
          "data-qa": "cart-table:ProductPrice"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.priceFormatted), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["level"]),
        ($props.handleTax)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['gfu-bt', $options.descriptionClasses, '_tc--light']),
              "data-qa": "cart-table:ProductTax"
            }, [
              _createElementVNode("span", null, [
                (_openBlock(), _createBlock(_component_localize, {
                  key: $options.taxFormatted,
                  resource: _ctx.Resources.YourPledge.CartTableOrderItemTaxValueLabel
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString($options.taxFormatted), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"]))
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(['gfu-bt', $options.descriptionClasses, '_tc--light']),
          "data-qa": "cart-table:ProductQuantity"
        }, _toDisplayString(_ctx.Resources.YourPledge.CartTableQuantityHeader) + ": " + _toDisplayString($props.quantity), 3 /* TEXT, CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(['gfu-bt', $options.descriptionClasses, '_tc--light', '_toe']),
          "data-qa": "cart-table:ProductOptions"
        }, _toDisplayString($options.optionsFormatted), 3 /* TEXT, CLASS */)
      ]),
      ($options.hasActions)
        ? (_openBlock(), _createBlock(_component_balloon_actions, {
            key: 0,
            actions: $options.balloonActions,
            mode: $options.balloonActionMode,
            theme: "white",
            class: _normalizeClass(['_right-0', '_top-a', '_grow-1', '_ai-fe', $options.balloonActionClasses]),
            "data-qa": "cart-table:EditItem"
          }, null, 8 /* PROPS */, ["actions", "mode", "class"]))
        : _createCommentVNode("v-if", true)
    ]),
    ($options.isErrorVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!$options.canEditItem && this.canEditPledge)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_base_icon, { name: "times-circle" }),
                _createTextVNode(" " + _toDisplayString(_ctx.Resources.YourPledge.YourPledgeInvalidValidationGenericMessage) + " ", 1 /* TEXT */),
                ($props.isActionRequired)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "gfu-link _tdu",
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.editPledge && $options.editPledge(...args))),
                      "data-qa": "cart-table:RequiredAction"
                    }, _toDisplayString(_ctx.Resources.YourPledge.EditPledgeLabel), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_base_icon, { name: "times-circle" }),
                _createTextVNode(" " + _toDisplayString($options.errorMessage) + " ", 1 /* TEXT */),
                ($props.isActionRequired)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "gfu-link _tdu",
                      onClick: _cache[1] || (_cache[1] = (...args) => ($options.openOptionsSelectionModal && $options.openOptionsSelectionModal(...args))),
                      "data-qa": "cart-table:RequiredAction"
                    }, _toDisplayString(_ctx.Resources.YourPledge.YourPledgeInvalidValidationCallToActionMessage), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.subitemsCounter > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.isSubitemsExpanded)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                class: "_tc--accent",
                onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.onToggleSubitems && $options.onToggleSubitems(...args)), ["prevent"])),
                "data-qa": "subitems-expanded"
              }, [
                _createVNode(_component_base_icon, { name: "chevron-up" }),
                _createElementVNode("span", null, [
                  _createVNode(_component_localize, {
                    resource: _ctx.Resources.YourPledge.CartTableOrderItemHideSetItemsLabel
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString($options.pluralizedSetItemsCount), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_8, _toDisplayString($options.subitemsCounter), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["resource"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: "#",
                class: "_tc--accent",
                onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.onToggleSubitems && $options.onToggleSubitems(...args)), ["prevent"]))
              }, [
                _createVNode(_component_base_icon, { name: "chevron-down" }),
                _createElementVNode("span", null, [
                  _createVNode(_component_localize, {
                    resource: _ctx.Resources.YourPledge.CartTableOrderItemShowSetItemsLabel
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_9, _toDisplayString($options.pluralizedSetItemsCount), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_10, _toDisplayString($options.subitemsCounter), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["resource"])
                ])
              ]))
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isSubitemsExpanded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(['_mt-3', '_grid', '_grid-cols-1', '_grid-cols-2--m', '_fd-r', $options.subitemBoxClassList])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.subitems, (subitem, index) => {
            return (_openBlock(), _createBlock(_component_cart_table_product_order_subitem, _mergeProps({
              key: `subitem.name-${index}`
            }, { ref_for: true }, subitem), null, 16 /* FULL_PROPS */))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (_ctx.isOptionsModalVisible)
      ? (_openBlock(), _createBlock(_component_order_item_modal, _mergeProps({ key: 3 }, $options.editOrderItemModalModel, {
          editing: true,
          onSubmit: $options.onEdit,
          onClose: $options.closeOptionsSelectionModal
        }), null, 16 /* FULL_PROPS */, ["onSubmit", "onClose"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}